import theme from '@/constants/theme';
import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  itemContainer: {
    margin: '0px 16px',
    position: 'relative',
    borderLeft: '3px solid #ffffff1a',
    padding: '8px 4px',
  },
  listIndicator: {
    width: 10,
    height: 10,
    borderRadius: 100,
    backgroundColor: theme.colors.primary,
    position: 'absolute',
    top: '50%',
    left: -6,
  },
  cardContainer: {
    backgroundColor: theme.colors.background.secondary,
    position: 'relative',
    padding: 16,
    marginLeft: 16,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  typeIndicator: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: 'inherit',
    color: theme.colors.text.caption,
  },
  type: {
    color: theme.colors.text.caption,
  },
  cardTitle: {
    color: theme.colors.text.title,
  },
  fixedIndicator: {
    position: 'absolute',
    backgroundColor: 'inherit',
    right: 16,
    top: 16,
  },
  pointsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: 'inherit',
  },
  pointsIndicator: {
    color: theme.colors.points,
    fontWeight: 'bold',
  },
};
